import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { R as Ratio } from './roche-image.types.js';
import { d as defineCustomElement$1 } from './roche-icon2.js';

const rocheAvatarCss = ":host{display:block;margin-top:3rem;margin-top:0;display:inline-block;border-radius:50%;overflow:hidden}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}::slotted(roche-image){margin:0}.fallback-avatar{display:flex;justify-content:center;align-items:center;width:100%;height:100%;background:#f5f5f2}roche-icon{display:flex;justify-content:center;height:62.5%}";
const RocheAvatarStyle0 = rocheAvatarCss;

const RocheAvatar = /*@__PURE__*/ proxyCustomElement(class RocheAvatar extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    componentDidLoad() {
        var _a;
        (_a = this.element.querySelector('roche-image')) === null || _a === void 0 ? void 0 : _a.setAttribute('ratio', Ratio.SQUARE);
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return (h("slot", { key: '920210e4cc05aed03d4189f8462ab78d51b2d13c', name: "image" }, h("div", { key: '99a6044a0548edd6cd9b2f60600c6df241f87d04', class: "fallback-avatar" }, h("roche-icon", { key: '99ba391a7bf5d9737911a3763bbfe66b6732ad54', icon: "default-avatar", height: "100%" }))));
    }
    get element() { return this; }
    static get style() { return RocheAvatarStyle0; }
}, [1, "roche-avatar"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-avatar", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-avatar":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheAvatar);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { RocheAvatar as R, defineCustomElement as d };

//# sourceMappingURL=roche-avatar2.js.map